export default {
  // returns if user is professinal or company
  doStartCompany () {
    if (!this.userIsCompany) {
      this.existsRegister('/v1/professional/steps/prices/status', (data, meta) => {
        if (!data.address) {
          this.statusAddress = data.address
          this.show = true
        }
      })
    }
    // not professional
    this.existsRegister('/v1/professional/steps/prices/status', (data, meta) => {
      if (!data.address && !data.staff) {
        this.statusAddress = data.address
        this.statusStaff = data.staff
        this.show = true
      }

      if (!data.staff && data.address) {
        this.statusAddress = data.address
        this.statusStaff = data.staff
        this.show = true
      }

      if (data.staff && data.address) {
        this.statusAddress = data.address
        this.statusStaff = data.staff
        this.show = false
      }
    })
  },
  onShow () {
    this.show = true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/resources/methods.js